import { render, staticRenderFns } from "./PaymentScheme.vue?vue&type=template&id=079afa1f"
import script from "./PaymentScheme.vue?vue&type=script&lang=js"
export * from "./PaymentScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports